module.exports = __webpack_public_path__ + "static/Vazir-d0b45fe799885bab47a9fc07de9563e3.woff";